import { useLoginUser } from "./providers/useLoginUserProvider";
import { Auth } from 'aws-amplify';

// ユーザ関連
export const useUser = () => {
  const { loginUser, setLoginUser } = useLoginUser();
  
  // セッション経過時間判断付きトークンのリフレッシュ
  const refreshToken = (async()=>{
    
    // 現在時刻を取得
    const nowTime = Math.floor(new Date().getTime()/1000);
    
    // 前回API実行時間から現在までは10時間以内なら、切れておればトークンリフレッシュする
    loginUser.envType === 'DEV' && console.log('経過秒',nowTime - loginUser.eTime);
    if( nowTime - loginUser.eTime < 60 * 60 * 10 ){
      
      // アクセストークンを取得（セッション内なら同じだし、外なら変わる）
// console.log('トークン取得開始');
      const user = await Auth.currentSession();
      const token = user.getAccessToken().getJwtToken() ? user.getAccessToken().getJwtToken() : loginUser.token;
// console.log('トークン取得終了',token,loginUser);
      
      // eTImeのリセット＋ついでに取得セッション更新（同じかもしれないが）
      await setLoginUser({
        username: loginUser.username,
        email: loginUser.email,
        userGroup: loginUser.userGroup,
        userKind: loginUser.userKind,
        envType: loginUser.envType,
        eTime: nowTime,
        token: token,
        param: loginUser.param,
        issue_cloud_list: loginUser.issue_cloud_list,
        case_search_days: loginUser.case_search_days,
        group_search_days: loginUser.group_search_days,
        mypage_search_days: loginUser.mypage_search_days,
        mailgroup_search_days: loginUser.mailgroup_search_days,
        sfdc_url: loginUser.sfdc_url,
        bu_list: loginUser.bu_list,
        mailgroup_class_list: loginUser.mailgroup_class_list,
        mailgroup_cloud_list: loginUser.mailgroup_cloud_list,
        max_group_search_days: loginUser.max_group_search_days,
        max_issue_search_days: loginUser.max_issue_search_days,
        max_case_search_days: loginUser.max_case_search_days,
        max_mail_search_days: loginUser.max_mail_search_days,
        nec_network: loginUser.nec_network,
        necFlag: loginUser.necFlag,
        department: loginUser.department,
        jobTitle: loginUser.jobTitle,
      });
      
      return( token );
    }
    
    // 最後の更新から1時間以上経過
    loginUser.envType === 'DEV' && console.log('トークンなし');
    return('');
    
  });
  
  return {
    refreshToken
  };
};